import type { ReplenishmentViewProps } from "./ReplenishmentView";
import { DRINK_MIX_CLASS, SPARKLING_CLASS } from "./constants";

/** One mount of the Replenishment page: its base path and what it carries. */
export type ReplenishmentPage = ReplenishmentViewProps & { basePath: string };

/**
 * Every place the Replenishment page mounts. The router mounts one route per
 * entry (routes.tsx) and the engine declarations Nucleus opens them through are
 * built from the same list (enginePages.ts), so a page added here is both routed
 * and declared. Tiny on purpose — constants, no component code — so the router
 * and the app config read it without loading the page.
 */
export const REPLENISHMENT_PAGES: readonly ReplenishmentPage[] = [
  // LMNT's independent replenishment results surface. Keep Core's
  // work-in-progress allocation workbench isolated on /allocation-engine.
  // One route object for Balance Walk and the two report tabs (Build
  // Plan, Transfer Plan), so switching tabs keeps the header, the run
  // selector, a run in progress AND the views themselves mounted.
  { basePath: "/replenishment" },
  // Supply — the Replenishment Balance Walk on its own page. The
  // full page stays routed at /replenishment (no tile); this is the
  // rail's cut of it.
  { basePath: "/supply", mode: "walk" },
  // Direct-nav only (no tile): the Replenishment page with its Balance
  // Walk at both production stages (First Pack / Finished Goods),
  // under test, Production and Transfers beside it as on
  // /replenishment. /supply and /replenishment keep the Finished
  // Goods walk they always had.
  { basePath: "/replenishmentsplittest", mode: "all", walkStages: true },
  // The per-class planning pages: Production + Transfers, scoped to
  // one product class each, with independently locked plans (one
  // class's committed horizon can run weeks ahead of the other's).
  { basePath: "/sparkling", mode: "plan", lockedClass: SPARKLING_CLASS },
  { basePath: "/drink-mix", mode: "plan", lockedClass: DRINK_MIX_CLASS },
];
